import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import { ProductsPage, ProductCategory } from './pages/Products';
import { ServicesPage } from './pages/ServicesNew';
import ServicePage from './pages/ServicePage';
import IndustriesNew from './pages/IndustriesNew';
import IndustryPage from './pages/IndustryPage';
import About from './pages/About';
import { BlogListIntegrated, BlogPostIntegrated } from './pages/BlogIntegrated';
import BlogPrivacyPolicy from './pages/BlogPrivacyPolicy';
import BlogTermsOfUse from './pages/BlogTermsOfUse';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import JobDetail from './pages/JobDetail';
import AdminIntegrated from './pages/AdminIntegrated';
import AdminLogin from './pages/AdminLogin';
import CMSDashboard from './pages/CMSDashboard';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<><Header /><Home /><Footer /></>} />
              <Route path="/products" element={<><Header /><ProductsPage /><Footer /></>} />
              <Route path="/products/:slug" element={<><Header /><ProductCategory /><Footer /></>} />
              <Route path="/services" element={<><Header /><ServicesPage /><Footer /></>} />
              {/* CMS-powered service pages */}
              <Route path="/services/:categorySlug" element={<><Header /><ServicePage /><Footer /></>} />
              <Route path="/services/:categorySlug/:subSlug" element={<><Header /><ServicePage /><Footer /></>} />
              <Route path="/industries" element={<><Header /><IndustriesNew /><Footer /></>} />
              <Route path="/industries/:industrySlug" element={<><Header /><IndustryPage /><Footer /></>} />
              <Route path="/industries/:industrySlug/:subSlug" element={<><Header /><IndustryPage /><Footer /></>} />
              <Route path="/about" element={<><Header /><About /><Footer /></>} />
              <Route path="/blog" element={<><Header /><BlogListIntegrated /><Footer /></>} />
              <Route path="/blog/privacy-policy" element={<><Header /><BlogPrivacyPolicy /><Footer /></>} />
              <Route path="/blog/terms-of-use" element={<><Header /><BlogTermsOfUse /><Footer /></>} />
              <Route path="/blog/:slug" element={<><Header /><BlogPostIntegrated /><Footer /></>} />
              <Route path="/careers" element={<><Header /><Careers /><Footer /></>} />
              <Route path="/careers/:slug" element={<><Header /><JobDetail /><Footer /></>} />
              <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/cms" element={<ProtectedRoute><CMSDashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminIntegrated /></ProtectedRoute>} />
            </Routes>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
